import {
  createContext,
  useContext,
  ReactNode,
  useEffect,
  useState,
} from "react";
import { getDatabase, ref, onValue } from "firebase/database";
import { DateTime } from "luxon";

type TimeContextType = {
  time: DateTime;
};

const TimeContext = createContext<TimeContextType | undefined>(undefined);

export const useTimeContext = () => {
  const context = useContext(TimeContext);
  if (!context) {
    throw new Error("useTimeContext must be used within a TimeProvider");
  }
  return context;
};

export const TimeProvider = ({ children }: { children: ReactNode }) => {
  const [serverOffset, setServerOffset] = useState<number>(0);
  const [currentTime, setCurrentTime] = useState(DateTime.now());

  // Get server time offset using Firebase Realtime Database
  useEffect(() => {
    const db = getDatabase();
    const offsetRef = ref(db, ".info/serverTimeOffset");

    const unsubscribe = onValue(offsetRef, (snap) => {
      const offset = snap.val();
      if (typeof offset === "number") {
        console.log("server offset", offset);
        setServerOffset(offset);
      }
    });

    return () => unsubscribe();
  }, []);

  // Update current time every minute
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(DateTime.now());
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  const time = currentTime.plus({ milliseconds: serverOffset });

  const value = {
    time,
  };

  return <TimeContext.Provider value={value}>{children}</TimeContext.Provider>;
};
